var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYandexDzenBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#yandex-dzen-black_svg__clip0_2202_4958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.314 14.314C12.43 16.26 12.291 18.686 12.13 24c4.954 0 8.374-.017 10.14-1.731C23.983 20.503 24 16.92 24 12.129c-5.314.171-7.74.3-9.686 2.185zM0 12.13c0 4.791.017 8.374 1.731 10.14C3.497 23.983 6.917 24 11.871 24c-.171-5.314-.3-7.74-2.185-9.686C7.74 12.43 5.314 12.291 0 12.13zM11.871 0C6.926 0 3.497.017 1.731 1.731.017 3.497 0 7.08 0 11.871c5.314-.171 7.74-.3 9.686-2.185C11.57 7.74 11.709 5.314 11.87 0zm2.443 9.686C12.43 7.74 12.291 5.314 12.13 0c4.954 0 8.374.017 10.14 1.731C23.983 3.497 24 7.08 24 11.871c-5.314-.171-7.74-.3-9.686-2.185z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 12.129v-.258c-5.314-.171-7.74-.3-9.686-2.185C12.43 7.74 12.291 5.314 12.13 0h-.258c-.171 5.314-.3 7.74-2.185 9.686C7.74 11.57 5.314 11.709 0 11.87v.258c5.314.171 7.74.3 9.686 2.185C11.57 16.26 11.709 18.686 11.87 24h.258c.171-5.314.3-7.74 2.185-9.686C16.26 12.43 18.686 12.291 24 12.13z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "yandex-dzen-black_svg__clip0_2202_4958"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgYandexDzenBlack;